import { ExtendedSeriesWithMeasurements } from '@/types/meters'
import HighCharts from 'highcharts'

export interface CommonChartProps {
    labelGetter?: (series: ExtendedSeriesWithMeasurements) => string
    disableLegend?: boolean
    exporting?: boolean
    title?: string
    slug?: string
}

export const useCommonChartOptions = (): HighCharts.Options => {
    return {
        xAxis: {
            type: 'datetime',
            dateTimeLabelFormats: {
                day: '%e %b',
                week: '%e %b %y',
                month: '%b %Y',
                year: '%Y',
            },
        },
    }
}
